// Angular
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

// Angular Material
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

// Local
import { EmulationService } from '@core/auth/emulation.service';

/**
 * Persistent, high-contrast banner shown whenever the current user is emulating another user. Makes the
 * emulation state unmistakable and provides a one-click exit. Rendered at the top of the app shell.
 */
@Component({
  selector: 'app-emulation-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './emulation-banner.component.html',
  styleUrls: ['./emulation-banner.component.scss'],
})
export class EmulationBannerComponent {
  private readonly emulationService = inject(EmulationService);

  /** True while emulation is active. */
  readonly isEmulating = this.emulationService.isEmulating;

  /** The emulated user's profile (name, organization) for display. */
  readonly profile = this.emulationService.emulatedProfile;

  /**
   * Ends emulation and reloads to the home page so all views re-fetch as the real admin, discarding any
   * target-scoped state held in memory.
   */
  exitEmulation(): void {
    this.emulationService.stopEmulation();
    window.location.assign('/');
  }
}
